import {Box, Button, Icon, Paper, Tab, Typography} from "@material-ui/core";
import TabContext from "@material-ui/lab/TabContext";
import TabList from "@material-ui/lab/TabList";
import TabPanel from "@material-ui/lab/TabPanel";
import React, {useEffect, useState} from "react";
import ImageLoader from "react-load-image";
import {connect} from "react-redux";
import {Link, NavLink, useParams, useRouteMatch} from "react-router-dom";
import defaultProfile from "../../../../assets/user.png";
import AppBreadCrumb from "../../../../components/AppBreadCrumb/AppBreadCrumb";
import ConfirmationDialog from "../../../../utilities/components/ConfirmationDialog/ConfirmationDialog";
import Preloader from "../../../../utilities/components/Preloader/Preloader";
import {PAGE_SIZE} from "../../../../utilities/constants";
import DepartmentAdministrators from "../../../Administrators/components/DepartmentAdmins/DepartmentAdmins";
import DepartmentDoctors from "../../../Doctors/components/DepartmentDoctors/DepartmentDoctors";
import {getPatientsForDeptRequest} from "../../../Patients/PatientsApiActions";
import {handleTabChange} from "../../DepartmentsActions";
import {getDeptByIdRequest, toggleActivationRequest,} from "../../DepartmentsApiActions";
import {useStyles} from "./styles";

/**
 * function to get message for activation dialog
 * @param dept: dept details
 * @returns {JSX.Element}
 * @constructor
 */
const ToggleActivationDialogMessage = ({dept, classes}) => {
  return (
    <>
      {dept && (
        <Box>
          Are you sure you want to {dept.active ? "deactivate" : "activate"} the{" "}
          <span className={classes.dialogMessageLabel}>{dept.name}</span>?
        </Box>
      )}
    </>
  );
};

/**
 * function to render department profile
 * @param location: location from router
 * @returns {JSX.Element}
 * @constructor
 */
const DepartmentProfile = ({
                             location,
                             getDeptById,
                             dept,
                             toggleActivation,
                             handleTabChange,
                             tabValue,
                             getAllPatients,
                           }) => {
  const classes = useStyles();
  const params = useParams();
  const match = useRouteMatch();
  const [
    openToggleActivationConfirmationDialog,
    setOpenToggleActivationConfirmationDialog,
  ] = useState(false);
  const currentUrlPath = match.path.split(":")[0];

  useEffect(() => {
    getDeptById(params.id).then((res) => {
    });
  }, [params.id, getDeptById]);

  const breadCrumbDataForOrgDeptProfilePage = [
    {
      icon: "business",
      name: "Clinics",
      path: "/orgs",
    },
    {
      name: `${
        location.state && location.state
          ? `${location.state.orgNameHistory}`
          : ""
      }`,
      path: `/orgs/${location.state && location.state.orgIdHistory}`,
    },
    {
      name: `${dept ? `${dept.name}` : ""}`,
      path: `/orgs/departments/${params.id}`,
    },
  ];

  const breadCrumbDataForAdminDeptProfilePage = [
    {
      icon: "apartment",
      name: "Departments",
      path: "/departments",
    },
    {
      name: `${dept ? `${dept.name}` : ""}`,
      path: `/departments/${params.id}`,
    },
  ];

  /**
   * function to get breadcrumb data for current url
   */

  const getBreadcrumbData = (urlPath) => {
    switch (urlPath) {
      case "/orgs/departments/": {
        return breadCrumbDataForOrgDeptProfilePage;
      }
      case "/departments/": {
        return breadCrumbDataForAdminDeptProfilePage;
      }
      default: {
        return [];
      }
    }
  };

  /**
   * function to handle tab change
   * @param e: event from button click
   * @param newValue: newValue from button click
   */
  const handleChange = (e, newValue) => {
    handleTabChange(newValue);
  };

  /**
   * function to toggle department activation
   */
  const onToggleActivation = () => {
    const data = {
      active: !dept.active,
    };

    toggleActivation(params.id, data).then((res) => {
      setOpenToggleActivationConfirmationDialog(false);
      getAllPatients(params.id, {
        page: 0,
        rowsPerPage: PAGE_SIZE,
        searchData: {},
      }).then((res) => {
      });
    });
  };

  return (
    <Box className={classes.outerContainer}>
      <AppBreadCrumb>
        {getBreadcrumbData(currentUrlPath).map((crumb, index) => (
          <Box
            key={index}
            component={NavLink}
            exact
            to={{
              pathname: crumb.path,
              state: {
                orgIdHistory: location.state && location.state.orgIdHistory,
                orgNameHistory: location.state && location.state.orgNameHistory,
              },
            }}
            className={classes.breadcrumbItem}
            activeClassName={classes.activeBreadcrumbItem}
          >
            {crumb.icon && (
              <Icon className={classes.breadcrumpIcon}>{crumb.icon}</Icon>
            )}
            <Box className={classes.breadcrumpLabel}>{crumb.name}</Box>
          </Box>
        ))}
      </AppBreadCrumb>

      <Box mt={3}>
        {dept && (
          <>
            <Box>
              <Box component={Paper} className={classes.profileContainer}>
                <Box className={classes.profileContentContainer}>
                  <Box>
                    <ImageLoader
                      src={dept.imageUrl ? dept.imageUrl : defaultProfile}
                    >
                      <img
                        alt="profile"
                        className={`${classes.profileImage} ${
                          dept.imageUrl ? "" : classes.imageBorder
                        }`}
                      />
                      <div className={classes.profileImageError}>{dept.id}</div>
                      <Preloader
                        className={`${classes.profileImage} ${
                          dept.imageUrl ? "" : classes.imageBorder
                        }`}
                      />
                    </ImageLoader>
                  </Box>
                  <Box className={classes.profileTextContainer}>
                    <Typography classes={{root: classes.nameText}}>
                      {dept.name}
                    </Typography>
                    <Typography classes={{root: classes.descText}}>
                      {dept.desc}
                    </Typography>

                    <Box className={classes.editDetailsButtonContainer}>
                      <Button
                        variant="contained"
                        color="primary"
                        disableElevation={true}
                        startIcon={<Icon>edit</Icon>}
                        component={Link}
                        to={{
                          pathname: `${match.path.split(":")[0]}edit/${
                            params.id
                          }`,
                          state: {
                            orgIdHistory:
                              location.state && location.state.orgIdHistory
                                ? location.state.orgIdHistory
                                : dept.OrganizationId,
                            orgNameHistory:
                              location.state && location.state.orgNameHistory,
                            deptIdHistory: dept && dept.id,
                            deptNameHistory: dept && dept.name,
                            orgTypeIdHistory:
                              dept.Organization && dept.Organization.typeId,
                          },
                        }}
                        classes={{root: classes.profileButton}}
                      >
                        Edit Details
                      </Button>
                    </Box>

                    <Box>
                      <Button
                        variant="contained"
                        color="primary"
                        disableElevation={true}
                        startIcon={
                          dept.active === false ? (
                            <Icon>check_circle_outline</Icon>
                          ) : (
                            <Icon>block</Icon>
                          )
                        }
                        classes={{
                          root: `${classes.profileButton} ${
                            dept.active
                              ? classes.blockButton
                              : classes.activeButton
                          }`,
                        }}
                        onClick={() =>
                          setOpenToggleActivationConfirmationDialog(true)
                        }
                      >
                        {dept.active === false ? "Activate" : "Deactivate"}
                      </Button>
                    </Box>
                  </Box>
                </Box>
              </Box>

              <Box component={Paper} className={classes.tabsContainer}>
                <TabContext value={tabValue}>
                  <TabList
                    onChange={handleChange}
                    indicatorColor="primary"
                    textColor="primary"
                    variant="fullWidth"
                  >
                    {/* <Tab label="Patients" value="1" /> */}
                    <Tab label="Staff" value="2"/>
                  </TabList>
                  {/* <TabPanel
                    value="1"
                    classes={{ root: classes.tabPanelContainer }}
                  >
                    <DepartmentPatients
                      orgIdHistory={
                        location.state && location.state.orgIdHistory
                          ? location.state.orgIdHistory
                          : dept.OrganizationId
                      }
                      orgNameHistory={
                        location.state && location.state.orgNameHistory
                      }
                      deptIdHistory={dept.id}
                      deptNameHistory={dept.name}
                    />
                  </TabPanel> */}

                  <TabPanel
                    value="2"
                    classes={{root: classes.tabPanelContainer}}
                  >
                    <DepartmentDoctors
                      orgIdHistory={
                        location.state
                          ? location.state.orgIdHistory
                          : dept.OrganizationId
                      }
                      orgNameHistory={
                        location.state && location.state.orgNameHistory
                      }
                      deptIdHistory={dept.id}
                      deptNameHistory={dept.name}
                    />
                  </TabPanel>
                  <TabPanel
                    value="3"
                    classes={{root: classes.tabPanelContainer}}
                  >
                    <DepartmentAdministrators
                      orgIdHistory={
                        location.state && location.state.orgIdHistory
                      }
                      orgNameHistory={
                        location.state && location.state.orgNameHistory
                      }
                      deptIdHistory={dept.id}
                      deptNameHistory={dept.name}
                    />
                  </TabPanel>
                </TabContext>
              </Box>
            </Box>
          </>
        )}

        {dept && (
          <Box>
            <ConfirmationDialog
              title={dept.active ? "Deactivate" : "Activate"}
              message={
                <ToggleActivationDialogMessage dept={dept} classes={classes}/>
              }
              open={openToggleActivationConfirmationDialog}
              setOpen={setOpenToggleActivationConfirmationDialog}
              onConfirm={onToggleActivation}
            />
          </Box>
        )}
      </Box>
    </Box>
  );
};

const mapStateToProps = (state) => {
  return {
    dept: state.departments.dept,
    tabValue: state.departments.tabValue,
  };
};

const mapDispatchToProp = (dispatch) => {
  return {
    getDeptById: (id) => {
      return dispatch(getDeptByIdRequest(id)).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    handleTabChange: (value) => {
      return dispatch(handleTabChange(value));
    },
    toggleActivation: (deptId, data) => {
      return dispatch(toggleActivationRequest(deptId, data)).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
    getAllPatients: (id, data) => {
      return dispatch(getPatientsForDeptRequest(id, data)).then(
        (res) => {
          return Promise.resolve(res);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProp)(DepartmentProfile);
